// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import { Link } from 'react-router-dom';
import contactBg from '../assets/images/companyImg.JPG';
import quality from '../assets/images/quality01.jpg';
import innovation from '../assets/images/innovation.jpg';
import inn from '../assets/images/inn.jpg'; 
import sponser06 from '../assets/logos/sponser06.jpeg';
import sponser05 from '../assets/logos/sponser05.png';
import sponser04 from '../assets/logos/sponser04.png';
import sponser03 from '../assets/logos/sponser03.jpeg';
import sponser02 from '../assets/logos/sponser02.jpeg';
import sponser01 from '../assets/logos/sponser01.png';
import partner from '../assets/logos/partner.png';

function Home() {
  return (
    <div>
      <Hero />
      <div className="container py-3 ">
        {/* Our Core Values */}
        <section className="py-0 col-dark"> {/* Assuming col-dark gives a dark background to this section */}
    <h2 className="text-center text-warning mb-4">Our Core Values</h2>
    <div className="row row-cols-1 row-cols-md-3 g-4">
        <div className="col ">
            <div className="card h-100 shadow-lg border-0 project-card"> {/* Added project-card, changed shadow, removed bg-warning */}
                <img
                    src={quality}
                    className="card-img-top rounded-top project-card-img" // Added project-card-img
                    alt="Quality"
                    style={{ height: '200px', objectFit: 'cover' }}
                />
                <div className="card-body text-center"> {/* Corrected 'bg-text-center' to 'text-center' */}
                    <h5 className="card-title ">Quality</h5>
                    <p className="card-text text-light">Uncompromising standards in every aspect of our work.</p>
                </div>
            </div>
        </div>
        <div className="col">
            <div className="card h-100 shadow-lg border-0 project-card"> {/* Added project-card, changed shadow, removed bg-warning */}
                <img
                    src={innovation}
                    className="card-img-top rounded-top project-card-img" // Added project-card-img
                    alt="Innovation"
                    style={{ height: '200px', objectFit: 'cover' }}
                />
                <div className="card-body text-center">
                    <h5 className="card-title">Innovation</h5>
                    <p className="card-text text-light">Embracing new technologies and creative solutions.</p>
                </div>
            </div>
        </div>
        <div className="col">
            <div className="card h-100 shadow-lg border-0 project-card"> {/* Added project-card, changed shadow, removed bg-warning */}
                <img
                    src={inn}
                    className="card-img-top rounded-top project-card-img" // Added project-card-img
                    alt="Sustainability"
                    style={{ height: '200px', objectFit: 'cover' }}
                />
                <div className="card-body text-center">
                    <h5 className="card-title ">Sustainability</h5>
                    <p className="card-text text-light">Building responsibly for a better tomorrow.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section className="my-5 py-3 text-center position-relative z-1">
            <h3 className="mb-4 text-warning">Our Valued Partners & Sponsors</h3>
            {/* <p className="lead mb-4">We are proud to collaborate with industry leaders.</p> */}

            {/* Sponsor Logos Container for Animation */}
            <div className="sponsors-marquee-container bg-dark-200 w-100">
                <div className="sponsors-marquee-content">
                    {/* Original set of logos */}
                    <img src={sponser01} alt="Sponsor 1 Logo" className="marquee-logo" />
                    <img src={sponser02} alt="Sponsor 2 Logo" className="marquee-logo" />
                    <img src={sponser03} alt="Sponsor 3 Logo" className="marquee-logo" />
                    <img src={sponser04} alt="Sponsor 4 Logo" className="marquee-logo" />
                    <img src={sponser05} alt="Sponsor 5 Logo" className="marquee-logo" />
                    <img src={sponser06} alt="Sponsor 6 Logo" className="marquee-logo" />
                    <img src={partner} alt="Partner logo" className="marquee-logo" />

                    {/* Duplicate set of logos for seamless loop */}
                    <img src={sponser01} alt="Sponsor 1 Logo" className="marquee-logo" />
                    <img src={sponser02} alt="Sponsor 2 Logo" className="marquee-logo" />
                    <img src={sponser03} alt="Sponsor 3 Logo" className="marquee-logo" />
                    <img src={sponser04} alt="Sponsor 4 Logo" className="marquee-logo" />
                    <img src={sponser05} alt="Sponsor 5 Logo" className="marquee-logo" />
                    <img src={sponser06} alt="Sponsor 6 Logo" className="marquee-logo" />
                    <img src={partner} alt="Partner Logo" className="marquee-logo"/>

                </div>
            </div>
        </section>

        <section className="py-5 my-5 position-relative overflow-hidden rounded-3 text-light">
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundImage: `url(${contactBg})`, 
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundAttachment: 'fluid', 
              opacity: 0.6, 
              zIndex: -3,
            }}
          ></div>

          <div className="container position-relative z-1">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center text-dark">
                <h2 className="mb-4">Ready to Discuss Your Project?</h2>
                <p className="lead mb-4">
                  Contact us today to learn how LI-YO & SONS can help you achieve your goals.
                </p>
                <Link to="/contact" className="btn btn-warning  me-md-2 mb-2 mb-md-0 btn-lg">Contact Us</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
